// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"43900f38","605":"125c3c0e","725":"9e9b96ef"}[chunkId] + ".chunk.js";
};